import React, { useState } from 'react';
import { is } from 'ramda';
import { useTranslation } from 'react-i18next';
import { formatMoneyWithSign } from 'utils/currencyHelper';

import useScreen from 'hooks/useScreen';
import { Box, Typography } from '@material-ui/core';

import InputWithSlider from 'sharedComponents/InputWithSlider';
import PercentInputField from 'sharedComponents/PercentInputField';
import { mobnthlyPaymentCalculatorInitialValues } from 'utils/calculatorsHelper';
import MobileCalculationsResult from './components/MobileCalculationsResult';
import DesktopCalculationsResult from './components/DesktopCalculationsResult';
import useStyles from './useStyles';

const MothlyPaymentCalculator = () => {
  const { isDesktop, isMobile } = useScreen();
  const classes = useStyles();
  const { t } = useTranslation();
  const [calculatorValues, setCalculatorValues] = useState(mobnthlyPaymentCalculatorInitialValues);

  const handleChange = field => value => {
    if (!is(Number, value)) return;

    setCalculatorValues({ ...calculatorValues, [field]: value });
  };

  const handleChangePercentValue = field => value => {
    if (!is(Number, value)) return;
    setCalculatorValues({ ...calculatorValues, [field]: value / 100 });
  };

  const { mortgageValue, interestRate, mortgageTerm } = calculatorValues;

  const pAndI = ((interestRate / 12) * mortgageValue) / (1 - (1 + interestRate / 12) ** (mortgageTerm * -12));
  const formattedMortgagePayment = formatMoneyWithSign(pAndI.toFixed(0), 'USD');

  return (
    <Box className={classes.container}>
      {isMobile && <MobileCalculationsResult mortgagePayment={formattedMortgagePayment} />}
      <Box className={classes.content}>
        {isDesktop && <DesktopCalculationsResult mortgagePayment={formattedMortgagePayment} />}
        <Box>
          <Box mt={3}>
            <Typography className={classes.inputHeader} variant="body1">
              {t('components.MothlyPaymentCalculator.mortgageAmountLabel')}
            </Typography>
            <InputWithSlider
              name="mortgageValue"
              className={classes.input}
              value={calculatorValues.mortgageValue}
              min={0}
              max={1500000}
              marksDivider={1000}
              onChange={handleChange('mortgageValue')}
              strictLimit
            />
          </Box>
          <Box mt={3}>
            <Typography className={classes.inputHeader} variant="body1">
              {t('components.MothlyPaymentCalculator.interestRateLabel')}
            </Typography>
            <PercentInputField
              value={calculatorValues.interestRate * 100}
              min={0}
              max={7}
              stepDiff={0.125}
              onChange={handleChangePercentValue('interestRate')}
            />
          </Box>
          <Box mt={3} mb={2}>
            <Typography className={classes.inputHeader} variant="body1">
              {t('components.MothlyPaymentCalculator.mortgageTermLabel')}
            </Typography>
            <InputWithSlider
              name="mortgageTerm"
              className={classes.input}
              value={calculatorValues.mortgageTerm}
              min={10}
              max={30}
              prefix=""
              marksDivider={1}
              onChange={handleChange('mortgageTerm')}
              strictLimit
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MothlyPaymentCalculator;



// WEBPACK FOOTER //
// ./src/sharedComponents/MothlyPaymentCalculator/MothlyPaymentCalculator.js